import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { useStores } from '../stores/RootStore'
import gql from 'graphql-tag'

const RESTORE_SELF = gql`
  mutation restoreSelf {
    sudoRestoreSelf
  }
`

export function useRestoreSelf () {
  const history = useHistory()
  const { stores: { auth } } = useStores()

  const [sudoRestoreSelfMutation, { loading, error }] = useMutation(RESTORE_SELF, {
    onCompleted: () => {
      console.debug('onComplete')
    }
  })

  const restoreSelf = async () => {
    await sudoRestoreSelfMutation()
    await auth.refresh()

    const existingId = auth.user && auth.user.id
    history.push(existingId ? `/admin/users/${existingId}/permissions` : '/admin/users')
  }

  const name = auth.user?.sudoer?.fullName?.() || auth.user?.sudoer?.primaryEmail || ''

  return { restoreSelf, loading, error, name }
}
